import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

export default function LogsList({
  id,
  items,
  renderPrimary,
  renderSecondary,
}) {
  return (
    <List id={id}>
      {items.map((item, index) => (
        <ListItem key={index} sx={{ py: 0.5 }}>
          <ListItemText
            primary={
              <Typography variant="body2">{renderPrimary(item)}</Typography>
            }
            secondary={
              <Typography variant="caption">{renderSecondary(item)}</Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  );
}
